import type { PokerGameTile } from '@ps/poker-games-tile-mappers';
import { isEmpty } from 'lodash';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { ScheduledTourn } from '@swf/generated/types/api/v0/SwHomeGames';
import {
  Loader,
  NoData,
  useGetScheduledTourn,
  useGetWidgetState,
  useMapGameData
} from '@swf/poker';

import NoDataIcon from '../../Tournaments/assets/no-data.svg';
import filterRegisteredTournaments from '../../Tournaments/utils/filterRegisteredTournaments';
import type { Props } from '../Container';

import {
  TXTCLI_Cash_Games,
  TXTCLI_My_Scheduled_Tournaments,
  TXTCLI_Scheduled_Tournaments,
  TXTWCL_No_Cash_Games_to_Show,
  TXTWCL_No_Tournaments_to_Show
} from './Lobby.messages.json';
import styles from './Lobby.scss';
import LobbyGameTileContainer from './LobbyGameTileContainer/LobbyGameTileContainer';

const getUpcomingTournaments = (tournaments: PokerGameTile[], scheduled: ScheduledTourn[]) => {
  const upcomingTournaments: PokerGameTile[] = [];
  scheduled.forEach((scheduled) => {
    const upcoming = tournaments?.find(
      (tournament) => scheduled.tournId?.toString() === tournament.id
    );
    if (upcoming) {
      return upcomingTournaments.push(upcoming);
    }
  });
  return upcomingTournaments;
};

const Lobby: React.FC<Props> = (props) => {
  const clubId = Number(props.match.params.clubId);
  const { clubs } = useGetWidgetState();
  const { scheduled, loadingScheduled } = useGetScheduledTourn({
    clubs,
    userClubsLoading: props.loading,
    clubId
  });

  const { mappedTables, mappedTournaments } = useMapGameData({
    shouldMapTables: true,
    shouldMapTournaments: true
  });

  const filteredTournaments = filterRegisteredTournaments({
    tournaments: mappedTournaments,
    scheduled
  });
  const upcomingTournaments = getUpcomingTournaments(mappedTournaments[clubId], scheduled);

  const showUpcoming = !isEmpty(upcomingTournaments);
  const showScheduled = !isEmpty(filteredTournaments[clubId]);
  const showTables = !isEmpty(mappedTables[clubId]);

  return (
    <Loader loading={props.loading || loadingScheduled}>
      <div className={styles.container}>
        {showUpcoming && (
          <LobbyGameTileContainer
            title={<Translation {...TXTCLI_My_Scheduled_Tournaments} />}
            games={upcomingTournaments}
          />
        )}
        {showScheduled && (
          <LobbyGameTileContainer
            title={<Translation {...TXTCLI_Scheduled_Tournaments} />}
            games={filteredTournaments[clubId]}
          />
        )}
        {showTables && (
          <LobbyGameTileContainer
            title={<Translation {...TXTCLI_Cash_Games} />}
            games={mappedTables[clubId]}
          />
        )}
        {!showUpcoming && !showScheduled && !showTables && (
          <NoData
            icon={<NoDataIcon />}
            primaryText={<Translation {...TXTWCL_No_Tournaments_to_Show} />}
            secondaryText={
              <>
                <span>& </span>
                <Translation {...TXTWCL_No_Cash_Games_to_Show} />
              </>
            }
          />
        )}
      </div>
    </Loader>
  );
};

export default Lobby;
